
// Form submission handling
document.addEventListener('DOMContentLoaded', function() {
    const bookingForms = document.querySelectorAll('custom-booking-form');
    const contactForms = document.querySelectorAll('form:not(custom-booking-form)');
    
    // Handle booking forms
    bookingForms.forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            const formData = new FormData(form);
            const data = {};
            formData.forEach((value, key) => {
                data[key] = value;
            });
            fetch('https://formspree.io/f/opulenceone23@gmail.com', {
method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
            .then(response => {
                if (response.ok) {
                    alert('Thank you for your booking request! We will contact you shortly.');
                    form.reset();
                } else {
                    throw new Error('Network response was not ok');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('There was a problem submitting your request. Please try again or contact us directly.');
            });
});
    });
    
    // Handle contact forms
    contactForms.forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            const formData = new FormData(form);
            const data = {};
            formData.forEach((value, key) => {
                data[key] = value;
            });
            fetch('https://formspree.io/f/opulenceone23@gmail.com', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
            .then(response => {
                if (response.ok) {
                    alert('Thank you for your message! We will respond as soon as possible.');
                    form.reset();
                } else {
                    throw new Error('Network response was not ok');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('There was a problem submitting your message. Please try again or contact us directly.');
            });
});
    });
forms.forEach(form => {
        form.addEventListener('submit', function(e) {
            e.preventDefault();
            
            // Get form data
            const formData = new FormData(form);
            const data = {};
            formData.forEach((value, key) => {
                data[key] = value;
            });
            
            // Here you would typically send the data to a server
            console.log('Form submitted:', data);
            
            // Show success message
            alert('Thank you for your submission! We will contact you shortly.');
            form.reset();
        });
    });
    
    // Mobile menu toggle would be handled by navbar component
});